import { IIntegrations } from '@/interfaces/integrations';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

export const Head = ({
  publicApiToken,
  widgetTarget,
  actionColor,
  integrations,
}: HeadProps) => {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const scriptAnalytics = integrations.analyticsId && (
    <>
      <script
        defer
        src={`https://www.googletagmanager.com/gtag/js?id=${integrations.analyticsId}`}
      ></script>
      <script
        defer
        src={`https://www.googletagmanager.com/gtag/js?id=G-V3J8VNFJ0S&l=ga4PlanneDataLayer`}
      ></script>
      <script
        defer
        dangerouslySetInnerHTML={{
          __html: `
                    window.ga4PlanneDataLayer = window.ga4PlanneDataLayer || [];
                    function gtagPlanne(){ga4PlanneDataLayer.push(arguments);}
                    gtagPlanne('js', new Date());
                    gtagPlanne('config', 'G-V3J8VNFJ0S');

                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}

                    gtag('js', new Date());
                    gtag('config', '${integrations.analyticsId}');
    
                    function trackeGASale(event, sale){
                      if(gtag){
                        const items = []
                        for(let x = 0; x < sale.items.length; x++){
                          let item = sale.items[x];
                          items.push({
                            item_id: item.product.id,
                            item_name: item.product.name
                          })
                        }

                        console.debug('trackeGASale', event, sale);

                        sendToGA(event, {
                          transaction_id: String(sale.id),
                          value: sale.total_amount_cents / 100,
                          currency: 'BRL',
                          items,
                          payment_method: sale.lastTransaction?.paymentMethod.code,
                        });
                      }
                    }
                    
                    function sendToGA(event, data){
                      console.debug('sendToGA', event, data, gtag);

                      const readyDataToSend = {
                        currency: data.currency,
                        value: data.value,
                        items: data.items,
                        transaction_id: data.transaction_id,
                        payment_method: data.payment_method,
                      }
                      if(gtag){
                        gtag('event', event, readyDataToSend)
                      }
                    }
                `,
        }}
      ></script>
    </>
  );

  const scriptAds = integrations.analyticsId && integrations.googleAdsId && (
    <script
      defer
      dangerouslySetInnerHTML={{
        __html: `
              gtag('config', '${integrations.googleAdsId}');   
        `,
      }}
    ></script>
  );

  const scriptsEventsGA = (
    <script
      async
      dangerouslySetInnerHTML={{
        __html: `
                function handleCheckoutInit(sale, buyer) {
                  console.debug('handleCheckoutInit', sale, buyer);
                  ${
                    integrations.facebookPixelId
                      ? "trackSale('InitiateCheckout', sale, buyer)"
                      : ''
                  }
                  ${
                    integrations.analyticsId
                      ? "trackeGASale('begin_checkout', sale)"
                      : ''
                  }
                }
    
                function handleSaleCompletion(sale, buyer){
                  console.debug('handleSaleCompletion', sale, buyer);
                  ${
                    integrations.facebookPixelId
                      ? "trackSale('Purchase', sale, buyer)"
                      : ''
                  }
                  ${
                    integrations.analyticsId
                      ? "trackeGASale('purchase', sale)"
                      : ''
                  }
                }
                `,
      }}
    ></script>
  );

  const scriptFacebookPixelId = integrations.facebookPixelId && (
    <>
      <script
        defer
        dangerouslySetInnerHTML={{
          __html: `
                        !function(f,b,e,v,n,t,s)
                        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window,document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', '${integrations.facebookPixelId}');
                        fbq('track', 'PageView');
                `,
        }}
      ></script>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `  <img height="1" width="1" src="https://www.facebook.com/tr?id=${integrations.facebookPixelId}&ev=PageView&noscript=1"/> `,
        }}
      ></noscript>
      <script
        defer
        dangerouslySetInnerHTML={{
          __html: `              
                      function trackSale(ev, sale, buyer){
                        if(!fbq){
                            return;
                        }
                  
                        var ids = [];
                        var numItems = 0;
                        for(var x = 0; x < sale.items.length; x++){
                          var item = sale.items[x];
                          ids.push(item.product.id);
                          numItems += item.quantity;
                        }

                        const userData = {
                          fn: buyer?.full_name?.trim().split(' ')[0] || '',
                          ln: buyer?.full_name?.trim().split(' ').slice(1).join(' ') || '',
                        }
                        console.debug('trackSaleFB', ev, sale, buyer);
                  
                        sendToFb(ev, {
                          content_type: 'product',
                          content_ids: ids,
                          num_items: numItems,
                          value: sale.total_amount_cents / 100,
                          currency: 'BRL',
                          payment_method: sale.lastTransaction?.paymentMethod.code,
                        }, userData);
                      }
                  
                      function sendToFb(eventName, customData, userData) {
                        console.debug('sendToFb', eventName, customData, userData, fbq);
                        // Check if pixel script was not blocked
                        if (fbq.instance) {
                            fbq('track', eventName, customData);
                        } else {
                            window.PlanneCore.sendFbPixelEvent('${integrations.facebookPixelId}', 'integrations.facebookPixelIdAccessToken', { eventName, customData, userData });
                        }
                      }
                `,
        }}
      ></script>
    </>
  );

  return (
    <>
      <Helmet>
        {isBrowser && (
          <script type="text/javascript">{`
                (function(w,d,t,u,c,v,y){if(w.plnn)return;y=w.plnn=function(){
                    y.callMethod?y.callMethod.apply(y,arguments):y.queue.push(arguments)};
                    y.queue=[];v=d.createElement(t);v.async=!0;v.src=u;
                    c=d.getElementsByTagName(t)[0];c.parentNode.insertBefore(v,c)})
                    (window,document,'script','${widgetTarget}/widget.js');
                    plnn('init', '${publicApiToken}');
                    plnn('parameter', 'actionColor', '${actionColor}');
                    plnn('parameter', 'checkout-page', '/pagamento/');
                    plnn('parameter', 'landing-page', '/');
                    plnn('parameter', 'checkout-back-to', '/');
                    plnn('parameter', 'account-page', '/minha-conta/');
                `}</script>
        )}
      </Helmet>
      <script src="/scripts/index.js" type="module"></script>
      <script
        src="/scripts/jquery-3.6.0.min.js"
        type="text/javascript"
      ></script>
      {scriptAnalytics}
      {scriptsEventsGA}
      {scriptFacebookPixelId}
      {scriptAds}
    </>
  );
};

interface HeadProps {
  publicApiToken: string;
  widgetTarget: string;
  actionColor: string;
  integrations: IIntegrations;
}
